<!--<h2>NYMAX Monthly Gas Natural Settlements</h2>-->
<div class="line-graph">
  <apx-chart
    class="line-apex-charts"
    #chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [stroke]="chartOptions.stroke"
    [colors]="chartOptions.colors"
    [dataLabels]="chartOptions.dataLabels"
    [legend]="chartOptions.legend"
    [markers]="chartOptions.markers"
    [grid]="chartOptions.grid"
    [yaxis]="chartOptions.yaxis"
    [title]="chartOptions.title"
  ></apx-chart>
  <div class="loadingShade" *ngIf="loading">
    <mat-spinner strokeWidth="3"></mat-spinner>
  </div>
</div>
